<template>
  <div @click.stop="handleClick" :class="containerClass" class="button">
    <span :class="[titleClass]" class="select-none">
      {{ formattedTitle }}
    </span>
    <div class="absolute-center">
      <IconLoader2 :class="[loadingClass]" class="loader animate-spin" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconLoader2 } from '@tabler/icons-vue'
import { computed, ref } from 'vue'

const props = defineProps<{
  type: 'solid' | 'chip' | 'outline'
  title: string
  disabled?: boolean
  color?: string
  callback: () => Promise<unknown>
}>()

const isLoading = ref(false)

const handleClick = async () => {
  if (props.disabled || isLoading.value) return

  isLoading.value = true
  await props.callback()
  isLoading.value = false
}

const formattedTitle = computed(() =>
  props.type === 'chip' ? props.title.toUpperCase() : props.title
)

const containerClass = computed(() => {
  const typeClasses = {
    chip: 'button-chip',
    solid: 'button-solid',
    outline: 'button-outline'
  }
  let baseClass = typeClasses[props.type]

  if (props.disabled) {
    baseClass += ' button-disabled hover:cursor-not-allowed'
  }
  if (props.color && props.type == 'outline'){
    baseClass += ` border border-red-500 text-red-500`
  }

  return baseClass
})

const titleClass = computed(() => (isLoading.value ? 'opacity-0' : 'opacity-100'))
const loadingClass = computed(() => (isLoading.value ? 'opacity-100' : 'opacity-0'))
</script>
